import React, { useEffect, useState } from "react";
import "./Home.scss"
import { getAddNewTaskDetail, getDashboardCounts, getNotificationList } from "../../apiCall";
import toast from "react-hot-toast";
import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import { useStateValue } from "../../StateProvider";
import { isAdmin } from "../../utils/adminAccess";
import { extractDateTime } from "../../utils/FormateDate";
import { DASHBOARD_NOTIFICATION_COUNT } from "../../Constants";
import Select from 'react-select'
import { convertToUserOptions, customStyles } from "../../utils/ConvertToOptions";

const Home = () => {
  const [{ userInfo }, dispatch] = useStateValue();
  const [dashboardCount, setDashboardCount] = useState([]);
  const [userFilter, setUserFilter] = useState(
    isAdmin(userInfo) ? "All" : userInfo.user_code
  );
  const [userList, setUserList] = useState([]);
  const navigate = useNavigate()

  const {
    isLoading,
    isFetching,
    data: staffListData,
    refetch,
  } = useQuery({
    queryKey: ["dashboard-count"],
    enabled: !(userInfo?.user_code === "undefined" || userInfo?.user_code === undefined) ? true : false,
    queryFn: async () => {
      // Perform the API call to fetch company info
      try {
        const response = await getDashboardCounts(
          userFilter,
          userInfo?.user_code
        );
        if (response?.status === 200) {
          setDashboardCount(response.data.data);
        } else if (response?.response) {
          toast.error(response?.response?.data?.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
        throw error;
      }
    },
  });

  const {
    isLoading: isUserListLoading,
    data: useList,
    refetch: userListreFetch,
  } = useQuery({
    queryKey: ["dashboard-userlist"],
    enabled: isAdmin(userInfo) ? true : false,
    queryFn: async () => {
      // Perform the API call to fetch company info
      try {
        dispatch({ type: "SET_LOADING", status: true });

        const response = await getAddNewTaskDetail();
        if (response?.status === 200) {
          setUserList(response.data.data.users_list);
        } else if (response?.response) {
          toast.error(response.response.data.status);
        }
        dispatch({ type: "SET_LOADING", status: false });

        return response;
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
        throw error;
      }
    },
    // enabled: isAdmin(userInfo) ? true : false,
  });

  const fetchNotificationList = async () => {
    // Perform the API call to fetch company info
    dispatch({ type: "SET_LOADING", status: true });

    try {
      let response;

      response = await getNotificationList(
        false, 0, 0, DASHBOARD_NOTIFICATION_COUNT
      );
      console.log(response)
      if (response?.status === 200) {
        setNotificationList(response.data.data);

      } else if (response?.response?.status) {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    dispatch({ type: "SET_LOADING", status: false });
  };

  const {
    data,
    refetch: refetchNotificationList,
  } = useQuery({
    queryKey: ["notification-list"],
    queryFn: () => fetchNotificationList(),
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [notificationList, setNotificationList] = useState([]);

  const handleUserChange = (option) => {
    const type = option.value;
    setUserFilter(type);

    // setDefaultValue();
  };
  const openNotification = (item) => {
    navigate(`notification?notifiction_type=dashboard_notification&notification_id=${item.ID}`)
  }

  useEffect(() => {
    if (userInfo?.user_code) {
      refetch();
    }
  }, [userFilter]);

  useEffect(() => {
    if (userInfo?.user_code) {
      if (isAdmin(userInfo)) {
        setUserFilter("All");
      } else {
        setUserFilter(userInfo.user_code);
      }
      refetch();
    }
  }, [userInfo]);
  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area home-content-area">
        <div className=" pt-10 pb-21 mt-n6 mx-n4" />
        <div className="container-fluid mt-n22 ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12 mb-2">
              {/* Page header */}
              <div className="d-flex justify-content-between align-items-center">
                <div className="mb-lg-0">
                  <h3 className="mb-0  ">Dashboard</h3>
                </div>
                {/* <div>
                  <a href="#!" className="btn btn-white">
                    Create New Project
                  </a>
                </div> */}
              </div>
            </div>
          </div>
          {isAdmin(userInfo) && (
            <div className="row mb-2 d-flex justify-content-center">
              <div className="col-lg-2 col-md-6  mt-3 mt-md-3">
                {/* <select
                  className="form-select"
                  aria-label="Default select example"
                  value={userFilter}
                  onChange={handleUserChange}
                  style={{ fontSize: "16px" }}
                >
                  <option disabled>Select User</option>
                  <option selected="All" value={"All"}>
                    All
                  </option>

                  {userList.map((item) => (
                    <option value={item}>{item}</option>
                  ))}
                </select> */}
                <Select
                  // className="form-select"
                  styles={customStyles}
                  value={{ label: userFilter, value: userFilter }}
                  placeholder="Select staff."
                  onChange={handleUserChange}

                  options={[{ label: "Select a user", value: "", isDisabled: true },{ label: "All", value: "All" }, ...convertToUserOptions(userList)]} />
              </div>
            </div>
          )}
          <div className="row">
            <Link
              to={`/task?status_filter=2&user_filter=All&search_filter=&task_type=over_due&user_code=${userFilter}`}
              className="col-xl-3 col-lg-6 col-md-6 col-6 mb-5"
            >
              {/* card */}
              <div className="card h-100 card-lift"
                style={{ borderRadius: ".5rem", background: "#d323237d", color: "white" }}
              >
                {/* card body */}
                <div className="card-body">
                  {/* heading */}
                  <div className="d-flex justify-content-center align-items-center mb-3">
                    <div>
                      <h4 className="mb-0 " >Over due</h4>
                    </div>
                    {/* <div className="icon-shape icon-md bg-primary-soft text-primary rounded-2">
                      <TbCalendarDue size={20} />
                    </div> */}
                  </div>
                  {/* project number */}
                  <div className="lh-1">
                    <h1 className=" mb-1 fw-bold" style={{ textAlign: "center" }} >
                      {dashboardCount?.overdue_count
                        ? dashboardCount?.overdue_count
                        : 0}
                    </h1>
                    {/* <p className="mb-0">
                      <span className="text-dark me-2">2</span>Completed
                    </p> */}
                  </div>
                </div>
              </div>
            </Link>
            <Link
              to={`/task?status_filter=2&user_filter=All&search_filter=&task_type=on_going&user_code=${userFilter}`}
              className="col-xl-3 col-lg-6 col-md-6 col-6 mb-5"

            >
              {/* card */}
              <div className="card h-100 card-lift"
                style={{ borderRadius: ".5rem", background: "#ffff007a" }}
              >
                {/* card body */}
                <div className="card-body">
                  {/* heading */}
                  <div
                    className="d-flex justify-content-center align-items-center
              mb-3"
                  >
                    <div>
                      <h4 className="mb-0">On Going</h4>
                    </div>
                    {/* <div
                      className="icon-shape icon-md bg-primary-soft text-primary
                rounded-2"
                    >
                      <BsListTask size={20} />
                    </div> */}
                  </div>
                  {/* project number */}
                  <div className="lh-1">
                    <h1 className="  mb-1 fw-bold" style={{ textAlign: "center" }}>
                      {dashboardCount?.ongoing_count
                        ? dashboardCount?.ongoing_count
                        : 0}
                    </h1>
                    {/* <p className="mb-0">
                      <span className="text-dark me-2">28</span>Completed
                    </p> */}
                  </div>
                </div>
              </div>
            </Link>
            <Link
              to={`/task?status_filter=3&user_filter=All&search_filter=&task_type=under_review&user_code=${userFilter}`}
              className="col-xl-3 col-lg-6 col-md-6 col-6 mb-5"
            >
              {/* card */}
              <div className="card h-100 card-lift"
                style={{ borderRadius: ".5rem", background: "#00800075" }}
              >
                {/* card body */}
                <div className="card-body">
                  {/* heading */}
                  <div
                    className="d-flex justify-content-center align-items-center
              mb-3"
                  >
                    <div>
                      <h4 className="mb-0">Under Review</h4>
                    </div>
                    {/* <div
                      className="icon-shape icon-md bg-primary-soft text-primary
                rounded-2"
                    >
                      <MdOutlineReviews size={20} />
                    </div> */}
                  </div>
                  {/* project number */}
                  <div className="lh-1">
                    <h1 className="  mb-1 fw-bold" style={{ textAlign: "center" }}>
                      {dashboardCount?.under_review_count
                        ? dashboardCount?.under_review_count
                        : 0}
                    </h1>
                    {/* <p className="mb-0">
                      <span className="text-dark me-2">1</span>Completed
                    </p> */}
                  </div>
                </div>
              </div>
            </Link>
            <Link
              to={`/task?status_filter=1&user_filter=All&search_filter=&task_type=up_coming&user_code=${userFilter}`}
              className="col-xl-3 col-lg-6 col-md-6 col-6  mb-5"
            >
              {/* card */}
              <div className="card h-100 card-lift">
                {/* card body */}
                <div className="card-body">
                  {/* heading */}
                  <div
                    className="d-flex justify-content-center align-items-center
              mb-3"
                  >
                    <div>
                      <h4 className="mb-0">Up Coming</h4>
                    </div>
                    {/* <div
                      className="icon-shape icon-md bg-primary-soft text-primary
                rounded-2"
                    >
                      <MdOutlineUpcoming size={20} />
                    </div> */}
                  </div>
                  {/* project number */}
                  <div className="lh-1">
                    <h1 className="  mb-1 fw-bold" style={{ textAlign: "center" }}>
                      {dashboardCount?.upcoming_count
                        ? dashboardCount?.upcoming_count
                        : 0}
                    </h1>
                    {/* <p className="mb-0">
                      <span className="text-dark me-2">1</span>Completed
                    </p> */}
                  </div>
                </div>
              </div>
            </Link>
          </div>
          {/* row  */}
          <div className="row ">
            <div className="col-xl-12 col-lg-12 col-md-12 col-12 mb-5 mb-xl-0">
              <div className="card h-100">
                {/* card header  */}
                <div className="card-header d-flex justify-content-between align-items-center bg-primary-soft" style={{ padding: "10px" }}>
                  <h4 className="mb-0 " style={{ fontSize: "20px" }}>
                    {" "}
                    Notifications
                  </h4>
                </div>
                {/* table  */}
                <div className="card-body">
                  <div className="table-responsive table-card">
                    <table className="table text-nowrap mb-0 table-centered table-hover home-table">
                      <thead className="table-light d-none">
                        <tr>
                          <th>Name</th>
                          <th>Deadline</th>
                          {/* <th>Status</th> */}
                        </tr>
                      </thead>
                      {notificationList.length > 0 ?
                        <tbody>
                          {notificationList.map(item =>

                            <tr className="d-flex ">
                              <td className=" subject d-flex flex-column  text-wrap w-100">
                                {" "}
                                <strong className="cursor-pointer" onClick={() => openNotification(item)}>{item?.Subject}</strong>
                                {/* <br /> */}
                                <div className="truncate">
                                  <small>
                                    {item?.Description}
                                  </small>
                                </div>
                              </td>
                              <td className=" d-flex flex-column align-items-end text-lg-end">
                                {" "}
                                <div className=" date ">
                                  <strong>{item?.SentBy}</strong>
                                  <small>
                                    <div>

                                      {extractDateTime(item.DtTime).date}
                                    </div>
                                    <div>

                                      {extractDateTime(item.DtTime).time}
                                    </div>

                                  </small>
                                </div>
                              </td>
                            </tr>
                          )}
                          <div className="row">
                            <div className="btn-wrapper d-flex justify-content-center">

                              <div className="btn btn-primary col-lg-2 col-md-4 col-12  " onClick={() => navigate("/notification?notifiction_type=unread_notifiction")}>View More</div>
                            </div>

                          </div>

                        </tbody> : <div className="m-5 fs-4">
                          <strong>No records found.!</strong>
                        </div>

                      }
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* row  */}
        </div>
      </div>
    </div>
  );
};

export default Home;
